<template>
    <div style="font-size: 1.3rem; margin-bottom: 1rem;">
        <slot>

        </slot>
    </div>
</template>

<script>
    export default {
        name: "headline"
    }
</script>

<style scoped>

</style>